import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=6dacefd2&scoped=true&"
var script = {}
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=6dacefd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dacefd2",
  null
  
)

export default component.exports